import { Component } from '@angular/core';

@Component({
  selector: 'bu-media-right',
  template: `
  <div class="media-right">
    <ng-content></ng-content>
  </div>`
})
export class BuMediaRightComponent {}
